import type { ChessMenuContext, MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import { backRow } from './backButton.js';

/** "Resume online" for a seat this browser still holds, or null when there is none. */
function resumeButton(ctx: ChessMenuContext): HTMLElement | null {
  const saved = ctx.online.getSavedSession();
  if (saved === null) return null;
  const active = ctx.online.getActiveSession();
  const label = active === null
    ? t('playMenu.resumeOnline', { code: saved.roomCode })
    : t('playMenu.resumeOnlineVs', { opponent: active.opponentName });
  return createCrestButton({ label, primary: true, onClick: () => void ctx.online.resumeRoom(saved.roomCode) });
}

export function createPlayMenuScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      shell.body.style.justifyContent = 'space-between';
      const resume = resumeButton(ctx);
      const buttons = el('div', { class: 'button-stack' }, [
        ...(resume === null ? [] : [resume]),
        createCrestButton({ label: t('playMenu.vsAi'), primary: resume === null, onClick: () => ctx.startLocalGame('bot') }),
        createCrestButton({ label: t('playMenu.vsHuman'), onClick: () => ctx.startLocalGame('human') }),
        createCrestButton({ label: t('playMenu.createOnline'), onClick: () => ctx.navigate('online-create') }),
        createCrestButton({ label: t('playMenu.joinOnline'), onClick: () => ctx.navigate('online-join') }),
        createCrestButton({ label: t('playMenu.importPosition'), onClick: () => ctx.navigate('pre-game') }),
      ]);
      shell.body.append(
        createMenuHeader({ title: t('playMenu.title') }),
        el('div', { class: 'about-center' }, [buttons]),
        backRow(ctx),
      );
      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
